<template>
  <page-view :class="isCustomizing ? 'cartPageView' : ''">
    <template #header>
      <base-header :title="headerTitle" />
    </template>
    <template #content>
      <v-card
        height="100%"
        flat
        :style="
          hasHorizontalScroll && !isCustomizing
            ? 'overflow-x: scroll; white-space: nowrap'
            : ''
        "
      >
        <v-row v-if="!isCustomizing" no-gutters align="start" justify="center">
          <template v-if="isFetching">
            <v-card
              class="d-flex flex-row justify-center align-center"
              height="700"
              width="1000"
              flat
            >
            </v-card>
          </template>
          <template v-else>
            <template v-if="errors.failedToFetch">
              <v-card
                class="d-flex flex-row align-center justify-center"
                height="700px"
                flat
              >
                <v-row no-gutters justify="center" align="center">
                  <v-col
                    cols="8"
                    class="d-flex justify-center align-center mb-3"
                  >
                    <span class="text-h5">{{
                      $t('message.errors.failedToAsyncPlans')
                    }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters align="center" justify="center">
                      <v-btn
                        color="primary"
                        class="ma-2 ml-3 white--text"
                        rounded
                        @click="loadModalInfo"
                      >
                        <span class="mx-2">{{ $t('message.tryAgain') }}</span>
                        <v-icon right dark> mdi-cached </v-icon>
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </template>
            <template v-else>
              <v-card
                v-if="!isCustomizing && filteredPlans.length"
                height="700"
                flat
                class="d-flex flex-row"
              >
                <div
                  v-for="(plan, i) in filteredPlans"
                  :key="i"
                  class="mr-4"
                  style="height: 655px"
                >
                  <v-card
                    v-if="plan.id !== 'prod_JnYYIEDhsa9SNE'"
                    :class="{
                      leftBorderCard: i + 1 < filteredPlans.length,
                      currentPlan: i === selectedItem,
                    }"
                    :style="
                      i === selectedItem
                        ? $vuetify.theme.dark
                          ? 'background: var(--v-neutral-darken1) !important'
                          : 'background-color: #3f55ee !important'
                        : $vuetify.theme.dark
                        ? ''
                        : 'background-color: #F8F8FF !important'
                    "
                    style="border: 1px solid #a0acff"
                    width="347px"
                    height="100%"
                    flat
                  >
                    <v-toolbar
                      v-if="i === selectedItem"
                      height="33"
                      class="d-flex align-center justify-center lightenText mb-6"
                      flat
                    >
                      <span class="notSelectedOption--text">
                        {{ $t('message.pages.Cart.currentPlan').toUpperCase() }}
                      </span>
                    </v-toolbar>
                    <v-toolbar
                      :color="$vuetify.theme.dark ? '' : '#F8F8FF'"
                      class="mb-6"
                      height="33"
                      flat
                      v-else
                    ></v-toolbar>
                    <v-row no-gutters style="height: 595px">
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col
                            cols="12"
                            align="center"
                            :class="isMobileBreakpoint ? 'mb-3' : 'mb-6'"
                          >
                            <v-row no-gutters align="center" justify="center">
                              <v-card
                                :width="
                                  plan.title.match('Legacy') ? '200px' : '94px'
                                "
                                height="38px"
                                color="#e6e8f8"
                                class="d-flex flex-row align-center justify-center rounded-pill"
                                flat
                              >
                                <span
                                  class="cartPlanText my-auto"
                                  :class="
                                    i === selectedItem
                                      ? 'primary--text'
                                      : $vuetify.theme.dark
                                      ? 'primary--text'
                                      : 'tabsSelected--text'
                                  "
                                >
                                  {{ plan.title }}
                                </span>
                              </v-card>
                            </v-row>
                          </v-col>
                          <v-col cols="12" class="mb-3">
                            <span class="text--start ml-6 cartBenefitsText">
                              <v-icon
                                color="lightenText"
                                size="16"
                                class="pb-1 mr-1"
                              >
                                mdi-check-circle
                              </v-icon>
                              <span
                                :class="
                                  i === selectedItem
                                    ? 'white--text'
                                    : 'textType2--text'
                                "
                              >
                                <b>
                                  {{
                                    calcMegabytes(
                                      plan.storage,
                                      'GB',
                                      'GB',
                                      true
                                    )
                                  }}
                                </b>
                                {{ $t('message.pages.Cart.ofStorage') }}
                                <v-icon
                                  :color="
                                    i === selectedItem ? 'contrast' : '#C2C6E7'
                                  "
                                  size="16"
                                  class="pb-1"
                                  @click="handleHelpDesk"
                                >
                                  mdi-help-circle
                                </v-icon>
                              </span>
                            </span>
                            <br />
                            <span
                              v-if="checkIfStorageAddonExist"
                              class="text--start ml-12 subText cartSubPricesText"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                            >
                              {{
                                `+ ${(
                                  storageAddon.prices[0].unit_amount / 100
                                ).toLocaleString(currencyLocale, {
                                  style: 'currency',
                                  currency: currency,
                                })} ${$t('message.pages.Cart.forAdditionalGB')}`
                              }}
                            </span>
                          </v-col>
                          <v-col cols="12">
                            <span
                              class="text--center ml-6 cartBenefitsText pb-1"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                            >
                              <v-icon
                                color="lightenText"
                                size="16"
                                class="pb-1 mr-1"
                              >
                                mdi-check-circle
                              </v-icon>
                              <b>
                                {{
                                  calcMegabytes(plan.traffic, 'GB', 'GB', true)
                                }}
                              </b>
                              {{ $t('message.pages.Cart.ofTrafficPerMonth') }}
                              <v-icon
                                :color="
                                  i === selectedItem ? 'contrast' : '#C2C6E7'
                                "
                                size="16"
                                class="pb-1"
                                @click="handleHelpDeskTraffic"
                              >
                                mdi-help-circle
                              </v-icon>
                            </span>
                            <br />
                            <span
                              v-if="i === selectedItem && currentPreBandwidth"
                              class="text--center ml-12 cartSubPricesText"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                            >
                              {{
                                `+ ${(currentPreBandwidth / 100).toLocaleString(
                                  currencyLocale,
                                  {
                                    style: 'currency',
                                    currency: currency,
                                  }
                                )} ${$t(
                                  'message.pages.Cart.forAdditionalTrafficGB'
                                )}`
                              }}
                            </span>
                            <span
                              v-else-if="trafficAddonPre.prices"
                              class="text--center ml-12 cartSubPricesText"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                            >
                              {{
                                `+ ${(
                                  trafficAddonPre.prices[0].unit_amount / 100
                                ).toLocaleString(currencyLocale, {
                                  style: 'currency',
                                  currency: currency,
                                })} ${$t(
                                  'message.pages.Cart.forAdditionalTrafficGB'
                                )}`
                              }}
                            </span>
                            <br />
                            <span
                              v-if="trafficAddonPos.prices"
                              class="text--center ml-12 cartSubPricesText"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                              >{{
                                `+ ${(
                                  trafficAddonPos.prices[0].unit_amount / 100
                                ).toLocaleString(currencyLocale, {
                                  style: 'currency',
                                  currency: currency,
                                })} ${$t(
                                  'message.pages.Cart.forAdditionalPosTrafficGB'
                                )}`
                              }}
                            </span>
                          </v-col>
                          <v-col cols="12" class="my-3">
                            <v-icon
                              class="ml-6 mr-2 pb-1"
                              color="lightenText"
                              size="16"
                            >
                              mdi-check-circle
                            </v-icon>
                            <span
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                              class="cartBenefitsText"
                              >{{ $t('message.pages.Cart.billedInReal') }}</span
                            >
                          </v-col>
                          <v-col cols="12" class="mb-3">
                            <v-icon
                              class="ml-6 mr-2 pb-1"
                              color="lightenText"
                              size="16"
                            >
                              mdi-check-circle
                            </v-icon>
                            <span
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                              class="cartBenefitsText"
                              >{{
                                $t('message.pages.customizeModal.perk1')
                              }}</span
                            >
                          </v-col>
                          <v-col cols="12" class="mb-3">
                            <v-icon
                              class="ml-6 mr-2 pb-1"
                              color="lightenText"
                              size="16"
                            >
                              mdi-check-circle
                            </v-icon>
                            <span
                              class="cartBenefitsText"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                              >{{
                                $t('message.pages.customizeModal.perk3')
                              }}</span
                            >
                          </v-col>
                          <v-col
                            v-if="plan.title === 'Gold'"
                            cols="12"
                            class="mb-3"
                          >
                            <v-icon
                              class="ml-6 mr-2 pb-1"
                              color="lightenText"
                              size="16"
                            >
                              mdi-check-circle
                            </v-icon>
                            <span
                              class="cartBenefitsText"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                              >{{ $t('message.pages.customizeModal.perk5') }}
                              <span class="ml-12 pl-2">{{
                                $t('message.pages.customizeModal.perk7')
                              }}</span>
                            </span>
                          </v-col>
                          <v-col cols="12" class="mb-3">
                            <v-icon
                              class="ml-6 mr-2 pb-1"
                              color="lightenText"
                              size="16"
                            >
                              mdi-check-circle
                            </v-icon>
                            <span
                              v-if="plan.title === 'Gold'"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                              class="cartBenefitsText"
                              >{{ $t('message.pages.Cart.even') }} 2
                              {{ $t('message.pages.Cart.simultaneousLives') }}
                            </span>
                            <span
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                              class="cartBenefitsText"
                              v-else-if="
                                plan.title === 'Bronze (Legacy)' ||
                                plan.title === 'Bronze' ||
                                plan.title === 'Silver'
                              "
                            >
                              1
                              {{ $t('message.pages.Cart.simultaneousLive') }}
                            </span>
                          </v-col>
                          <v-col cols="12" class="mb-3">
                            <span
                              v-if="
                                plan.title === 'Gold' || plan.title === 'Silver'
                              "
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'textType2--text'
                              "
                              class="cartBenefitsText"
                            >
                              <v-icon
                                class="ml-6 mr-2 pb-1"
                                color="lightenText"
                                size="16"
                              >
                                mdi-check-circle </v-icon
                              >{{ $t('message.pages.Cart.even') }}
                              {{ plan.users }}
                              {{
                                $t(
                                  'message.pages.customizeModal.addonUsers'
                                ).toLowerCase()
                              }}
                            </span>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="d-flex flex-row align-end">
                        <v-row no-gutters>
                          <v-col cols="12" align="center">
                            <span
                              class="text--center cartPriceText"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : 'primary--text'
                              "
                            >
                              {{
                                (0)
                                  .toLocaleString(currencyLocale, {
                                    style: 'currency',
                                    currency: currency,
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })
                                  .replace(/\d/g, '')
                                  .trim()
                              }}
                              <span class="text-h5">
                                <b>
                                  {{
                                    plan.price.toLocaleString(currencyLocale, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  }}
                                </b>
                              </span>
                              /{{ $t('message.month') }}</span
                            >
                          </v-col>
                          <v-col cols="12" align="center">
                            <span
                              class="pr-3 cartBenefitsText"
                              :class="
                                i === selectedItem
                                  ? 'white--text'
                                  : '#585D83--text'
                              "
                            >
                              + {{ $t('message.pages.Cart.additional') }}
                            </span>
                          </v-col>
                          <v-col cols="12" align="center" class="pb-6 pt-6">
                            <v-btn
                              width="300px"
                              @click="handleCheckout(plan, i === selectedItem)"
                              :outlined="i === selectedItem"
                              :color="i === selectedItem ? 'white' : 'primary'"
                              height="40"
                              :disabled="!isRootUser && !hasEditPlanPerm"
                            >
                              <span v-if="i === selectedItem">{{
                                $t('message.pages.Cart.customizeYourPlan')
                              }}</span>
                              <span v-else-if="i > selectedItem">{{
                                $t('message.pages.Cart.doUpgrade')
                              }}</span>
                              <span v-else-if="i < selectedItem">{{
                                $t('message.pages.Cart.doDowngrade')
                              }}</span>
                              <span v-else>{{
                                $t('message.pages.Cart.doUpgrade')
                              }}</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-card>
            </template>
          </template>
        </v-row>
        <customize-plan
          :plan="infoPlan"
          :noPlanChange="isSamePlan"
          @handleBackToCart="handleBackToCart"
          @handleBackToDashboard="handleBackToDashboard"
          v-else
        />
      </v-card>
    </template>
  </page-view>
</template>

<script>
import planApi from '@/services/planApi'
import userApi from '@/services/userApi'
import calcMegabytesMixin from '@/utils/calcMegabytes'
import CustomizePlan from '@/components/CustomizePlan.vue'
import { mapMutations, mapState } from 'vuex'
import {
  PANDA_HELP_STORAGE_LINK,
  PANDA_HELP_TRAFFIC_LINK,
} from '@/config/envs.js'
import PageView from '@/layout/PageView.vue'

export default {
  name: 'Cart',
  components: {
    CustomizePlan,
    PageView,
    BaseHeader: () => import('@/components/BaseHeader.vue'),
  },
  mixins: [calcMegabytesMixin],
  data: () => ({
    isFetching: false,
    plansData: [],
    addonsData: [],
    isCustomizing: false,
    infoPlan: {},
    noPlanChange: false,
    storageAddon: {},
    trafficAddonPre: {},
    trafficAddonPos: {},
    errors: {
      failedToFetch: false,
    },
    currency: 'brl',
    currencyLocale: 'pt-BR',
    isBeta: false,
  }),
  computed: {
    ...mapState({
      products: (state) => state.user.products,
      planInfo: (state) => state.user.userPlanInfo,
      onlyCustomizing: (state) => state.user.onlyCustomizing,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      windowWidth: (state) => state.user.windowWidth,
    }),
    hasHorizontalScroll() {
      return this.$store.state.user.windowWidth < 1450 ?? false
    },
    headerTitle() {
      if (this.isCustomizing) {
        return this.$i18next.t('message.pages.Cart.customizeTitle')
      }
      return this.$i18next.t('message.pages.Cart.planTitle')
    },
    isRootUser() {
      if (!this.$store.state.user.userAllInfo) return false
      return this.$store.state.user.userAllInfo.is_root ?? false
    },
    hasEditPlanPerm() {
      return (
        (this.$store.state.user.userPermissions?.includes('post-plan') &&
          this.$store.state.user.userPermissions?.includes('put-plan')) ??
        false
      )
    },
    currentPlanStorage() {
      if (this.planInfo.limit?.storage_plan) {
        return this.planInfo.limit.storage_plan
      }
      return false
    },
    currentPreBandwidth() {
      if (this.planInfo.addons?.traffic) {
        const prePaidBandwidth = this.planInfo.addons.traffic.filter(
          ({ charge, type }) => {
            return charge === 'pre' && type === 'traffic'
          }
        )
        if (!prePaidBandwidth.length) return false
        return prePaidBandwidth[0].unit_amount
      }
      return false
    },
    isListedOnPlans() {
      let userPlan = this.filteredPlans.find(
        (plan) => plan.title === this.planInfo?.subscription?.name
      )
      return userPlan || !this.planInfo?.subscription
    },
    selectedItem() {
      if (this.planInfo.subscription !== null) {
        const userPlanName = this.planInfo?.subscription?.name || 'NONE'
        return this.filteredPlans
          .map((plan) => plan.title)
          .indexOf(userPlanName)
      }
      return 'NONE'
    },
    modalWidth() {
      if (this.isCustomizing) return '520'
      return '1080'
    },
    filteredPlans() {
      let currentPlan = this.planInfo.subscription
        ? this.planInfo.subscription
        : null
      let plansResponse = this.plansData.map((plan) => {
        const price = plan.prices.find(
          (price) => price.recurring.interval === 'month'
        )
        const finalPlan = {
          title: plan.name,
          price: price.unit_amount / 100,
          prices: plan.prices,
          storage: plan.metadata.storage,
          traffic: plan.metadata.transfer,
          value: price.id,
          id: plan.id,
          users: plan.metadata?.users ?? '0',
        }
        return finalPlan
      })

      let plansNames = this.plansData.map((plan) => plan.name)

      if (currentPlan) {
        let isInDefaultPlans = plansNames.indexOf(currentPlan.name)

        if (isInDefaultPlans === -1) {
          plansResponse.push({
            title: currentPlan.name,
            price: currentPlan.unit_amount / 100,
            prices: currentPlan.prices,
            storage: currentPlan.metadata.storage,
            traffic: currentPlan.metadata.transfer,
            value: currentPlan.id,
            id: currentPlan.id,
          })
        }
      }

      let ascendingPlans = plansResponse.sort(
        (a, b) => parseFloat(a.price) - parseFloat(b.price)
      )
      return ascendingPlans.filter((el) => {
        //const title = el.title?.toLowerCase()
        //return title === 'bronze' || title === 'silver' || title === 'gold'
        return el
      })
    },
    isSamePlan() {
      if (this.planInfo?.subscription?.name) {
        return (
          this.planInfo?.subscription.name === this.infoPlan?.title &&
          this.planInfo?.subscription?.status !== 'trialing'
        )
      }
      return false
    },
    checkIfStorageAddonExist() {
      return (
        Object.keys(this.storageAddon).length !== 0 && this.storageAddon.prices
      )
    },
  },
  async mounted() {
    this.isBeta = location.search.match('beta')
    this.$root.$emit('changeNavItem', false)
    if (
      this.products.plans &&
      this.products.addons &&
      this.planInfo.subscription !== null
    ) {
      this.plansData = this.products.plans
      this.addonsData = this.products.addons
    } else {
      this.isFetching = true
      this.$root.$emit('setGlobalLoading', { open: true })
      if (this.planInfo.currency) {
        await Promise.all([this.getPlans(), this.loadPlanData()])
      } else {
        await this.loadPlanData()
        await this.getPlans()
      }
      this.$root.$emit('setGlobalLoading', { open: false })
      this.isFetching = false
    }
    if (this.planInfo.subscription && this.planInfo.subscription !== null) {
      let userPlan = this.filteredPlans.find(
        (plan) => plan.title === this.planInfo?.subscription?.name
      )
      let userActualPlan = this.planInfo?.subscription
      if (this.onlyCustomizing) {
        if (!userPlan) {
          this.handleCheckout({
            title: userActualPlan.name,
            price: (userActualPlan.unit_amount / 100)
              .toFixed(2)
              .replace('.', ','),
            prices: userActualPlan.prices,
            storage: userActualPlan.metadata.storage,
            traffic: userActualPlan.metadata.transfer,
            value: userActualPlan.id,
            id: userActualPlan.id,
          })
        } else {
          this.handleCheckout(userPlan)
        }
      } else {
        this.infoPlan = {
          title: userActualPlan.name,
          price: (userActualPlan.unit_amount / 100)
            .toFixed(2)
            .replace('.', ','),
          prices: userActualPlan.prices,
          storage: userActualPlan.metadata.storage,
          traffic: userActualPlan.metadata.transfer,
          value: userActualPlan.id,
          id: userActualPlan.id,
        }
      }
    }
    for (let i = 0; i < this.addonsData.length; i++) {
      let addon = this.addonsData[i]
      if (
        addon.metadata.type === 'storage' &&
        addon.metadata.charge === 'pre'
      ) {
        this.storageAddon = addon
      }
      if (
        addon.metadata.type === 'traffic' &&
        addon.metadata.charge === 'pre'
      ) {
        this.trafficAddonPre = addon
      }
      if (
        addon.metadata.type === 'traffic' &&
        addon.metadata.charge === 'pos'
      ) {
        this.trafficAddonPos = addon
      }
    }
    this.setCurrencyConfig()
    this.$root.$on('getBackToPlans', () => {
      this.isCustomizing = false
    })
    this.$root.$on('isChangingPlan', () => {
      this.UPDATE_ONLY_CUSTOMIZING(false)
      this.isCustomizing = false
    })
    this.$root.$on('onlyCustumizingByPlanModal', () => {
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.isCustomizing = true
    })
  },
  beforeDestroy() {
    this.$root.$off('getBackToPlans')
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_PRODUCTS',
      'UPDATE_USER_PLAN_INFO',
      'UPDATE_ONLY_CUSTOMIZING',
      'UPDATE_JUST_FEW_CUSTOMIZING',
    ]),
    setCurrencyConfig() {
      const currency = this.planInfo.currency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    async loadPlanData() {
      this.loading = true
      try {
        const [ret, userLimit] = await Promise.all([
          planApi.getSubscription(),
          userApi.getUserLimit(),
        ])
        this.UPDATE_USER_PLAN_INFO({
          addons: ret.data.addons,
          currency: ret.data.currency,
          subscription_id: ret.data.subscription_id,
          subscription: ret.data.subscriptions,
          limit: userLimit.data,
          planId: ret.data.subscriptions.id,
          type_payment: ret.data.type_payment,
          subscription_metadata: ret.data.subscription_metadata ?? {},
          user: {
            name: ret.data.name,
            email: ret.data.email,
          },
        })
      } catch (e) {
        this.error = true
        if (e) {
          userApi.fixUserLimit()
        }
      }
      this.$root.$emit('showAccountWarning')
      this.loading = false
    },
    handleBackToDashboard() {
      this.$router.push({ name: 'Videos' })
    },
    handleBackToCart() {
      this.UPDATE_JUST_FEW_CUSTOMIZING(false)
      this.UPDATE_ONLY_CUSTOMIZING(false)
      this.isCustomizing = false
    },
    selectPlan() {
      this.isCustomizing = true
    },
    async getPlans() {
      try {
        const ret = await planApi.getPlans(this.planInfo.currency)
        this.UPDATE_PRODUCTS(ret.data)
        this.plansData = ret.data.plans
        this.addonsData = ret.data.addons
      } catch (e) {
        this.failedToFetch = true
      }
    },
    formatPrice(price) {
      return parseFloat(price).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    handleCheckout(plan, willDoJustFewCustomizing) {
      if (willDoJustFewCustomizing) {
        this.UPDATE_JUST_FEW_CUSTOMIZING(true)
      }
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.infoPlan = plan
      this.isCustomizing = true
    },
    handleHelpDesk() {
      window.open(`${PANDA_HELP_STORAGE_LINK}`, '_blank')
    },
    handleHelpDeskTraffic() {
      window.open(`${PANDA_HELP_TRAFFIC_LINK}`, '_blank')
    },
    handleBack() {
      if (this.onlyCustomizing) {
        this.isCustomizing = true
      } else {
        this.handleBackToDashboard()
      }
    },
  },
  watch: {
    'planInfo.currency': {
      async handler() {
        this.setCurrencyConfig()
        this.isFetching = true
        this.$root.$emit('setGlobalLoading', { open: true })
        try {
          const ret = await planApi.getPlans(this.planInfo.currency)
          this.UPDATE_PRODUCTS(ret.data)
          this.plansData = ret.data.plans
          this.addonsData = ret.data.addons
          for (let i = 0; i < this.addonsData.length; i++) {
            let addon = this.addonsData[i]
            if (
              addon.metadata.type === 'storage' &&
              addon.metadata.charge === 'pre'
            ) {
              this.storageAddon = addon
            }
            if (
              addon.metadata.type === 'traffic' &&
              addon.metadata.charge === 'pre'
            ) {
              this.trafficAddonPre = addon
            }
            if (
              addon.metadata.type === 'traffic' &&
              addon.metadata.charge === 'pos'
            ) {
              this.trafficAddonPos = addon
            }
          }
        } catch (e) {
          this.errors.failedToFetch = true
        }
        this.$root.$emit('setGlobalLoading', { open: false })
        this.isFetching = false
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.subText {
  padding-top: 10px;
}

.leftBorderCard {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.currentPlan {
  font-weight: 500;
  text-align: left;
  text-transform: none;
  cursor: default;
}
.cartPlanText {
  font-weight: 500;
  font-size: 18px;
  line-height: 120%;
}
.cartBenefitsText {
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
}
.cartSubPricesText {
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
}
.cartPriceText {
  font-weight: 400;
  font-size: 20px;
  line-height: 120%;
}
</style>

<style>
.cartPageView .page-view__content {
  padding: 0rem !important;
}
</style>
